import { Reducer } from 'redux';
import { WidgetActionType } from '../actions';
import { WidgetRpcStreamAction } from './actions';

type MapResponse<T, TResponse> = (response: TResponse) => T;

export function createRpcStreamReducer<TWidgetDataState, TResponse>(
    initialState: TWidgetDataState,
    mapResponse: MapResponse<TWidgetDataState, TResponse>
): Reducer<TWidgetDataState, WidgetRpcStreamAction<TResponse>> {
    return (
        state: TWidgetDataState = initialState,
        action: WidgetRpcStreamAction<TResponse>
    ) => {
        switch (action.type) {
            case WidgetActionType.WIDGET_RECEIVE_RPC_STREAM_RESPONSE: {
                if (!action.payload || !action.payload.response) {
                    return state;
                }

                return mapResponse(action.payload!.response);
            }
            case WidgetActionType.WIDGET_CLEAR_STREAM_DATA: {
                return {
                    ...initialState,
                };
            }
        }
        return state;
    };
}
